// extracted by mini-css-extract-plugin
export default {"hero":"home_hero__xONoT","logo":"home_logo__G2w5f","wave":"home_wave__z9UiB","lead":"home_lead__cb1vI","body":"home_body__01oU2"};